import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useMatch, useNavigate } from "react-router-dom";
import { useAppStore } from "../../stores/RootStore";
import { Separator } from "../../ui/Separator";
import { VerticalTabs, VerticalTabsContent, VerticalTabsList, VerticalTabsTrigger } from "../../ui/Tabs/VerticalTabs";
const settingsPages = [
    {name: "settings", path: "", maxWidth: "768"},
    {name: "apps", path: "apps", maxWidth: "768"},
    {name: "participants", path: "participants", maxWidth: "768"},
    {name: "global_triggers", path: "global_triggers", maxWidth: "768"},
    {name: "logs", path: "logs", maxWidth: "768"}
]

export const Settings = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("settings")
  const navigate = useNavigate()
  const location = useLocation();
  const currentSite = useAppStore().currentSite

    // useEffect(() => {
    //   switch (location.pathname) {
    //     case "/settings":
    //     case "/settings/":
    //       setValue("settings");
    //       break;
    //     case "/settings/apps":
    //       setValue("apps");
    //       break;
    //     case "/settings/participants":
    //     case "/settings/participants/":
    //       setValue("participants");
    //       break;
    //     case "/settings/global_triggers":
    //       setValue("global_triggers");
    //       break;
    //     case "/settings/logs":
    //       setValue("logs");
    //       break;
    //     default:
    //       setValue("settings");
    //       break;
    //   }
    // }, [location.pathname]);

  function changeTab(item: any) {
    navigate(item.path)
    setValue(item.name)
  }


  return (
    <div className="flex flex-col w-full h-full bg-muted">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          {location.pathname == "/settings/" || location.pathname == "/settings" ? <span className="font-medium">{t("settings")}</span> : <NavLink to={"/settings"}><span className="font-medium">{t("settings")}</span></NavLink>}
          <span>/</span>
          <span className="font-medium">{t(value)}</span>
        </div>
      </div>
      <Separator className="flex-none"/>
        <>
            <VerticalTabs defaultValue={"main"} value={value} onValueChange={() => {}} orientation="vertical" className="flex bg-background relative h-full m-6 rounded overflow-hidden">
                <VerticalTabsList className="flex-none">
                    {settingsPages.map(p => (
                        <VerticalTabsTrigger key={p.name} className="data-[state=active]:bg-primary data-[state=active]:text-white" value={p.name} onClick={() => changeTab(p)}>
                            {t(`${p.name}`)}
                        </VerticalTabsTrigger> 
                    ))}
                </VerticalTabsList>
                <Separator orientation="vertical"/>
                    <div className="flex flex-col w-full h-full relative overflow-hidden">
                        {settingsPages.map(p => (
                            <VerticalTabsContent key={p.name} className={`flex flex-col max-w-[${p.maxWidth}px] w-full data-[state=active]:h-full`} value={p.name}>
                                <Outlet />
                            </VerticalTabsContent> 
                        ))}
                    </div>
            </VerticalTabs>
        </>
    </div>
  )
};
